import { T } from "../../../../../_ovlclient/src/global/globals"

import { SYSBaseElement } from "../../../../../_ovlclient/src/library/sysbaseelement"
import { SYSConfig, html } from "../../../../../_ovlclient/src"

export class NewServiceFormFooter extends SYSBaseElement {
  async getUI() {
    return html` <div class="fd-layout-panel__footer disclaimerfooter">
        <div>
          <p></p>
            ${T("NewServiceGoogleRecaptchaDisclaimer")}
            ${T("NewServiceDirectoriesAPIDisclaimer")} &nbsp; &nbsp;
            ${SYSConfig._system.versionInfo.frontend.app.version}
          </p>
        </div>
      </div>`
  }
}
